<div class="accordion"><ng-content></ng-content></div>
